import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { ENDPOINTS } from "../../../../config/api";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../../components/private/pagination";
import SearchSelect from "../../../../components/private/searchselect";
import * as bootstrap from "bootstrap";

const InformacionGeneral = () => {

  const { token, authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [informacion, setInformacion] = useState([]);
  const [loading, setLoading] = useState(true);

  // =========================================
  // FILTROS
  // =========================================

  const [contratoFilter, setContratoFilter] = useState("");
  const [contratanteFilter, setContratanteFilter] = useState("");
  const [programFilter, setProgramFilter] = useState("");
  const [fechaFilter, setFechaFilter] = useState("");

  const [programOptions, setProgramOptions] = useState([]);
  const [selectedInfo, setSelectedInfo] = useState(null);

  // =========================================
  // PAGINACIÓN
  // =========================================

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // =========================================
  // CARGAR INFORMACIÓN
  // =========================================

  useEffect(() => {

    if (!token) return;

    const loadInformacion = async () => {

      setLoading(true);

      try {

        const data = await authFetch(ENDPOINTS.get_informacion_general);

        if (data.success && data.data) {

          setInformacion(data.data);

          // =========================
          // OPTIONS PROGRAMAS
          // =========================
          const uniquePrograms = [
            ...new Map(
              data.data.map((item) => [
                item.id_programa,
                {
                  value: item.id_programa,
                  label: `${item.program_name} - ${item.area_name}`
                }
              ])
            ).values()
          ];

          setProgramOptions(uniquePrograms);

        } else {

          setInformacion([]);

        }

      } catch (error) {
        console.error("Error cargando información general:",error);
        setInformacion([]);
      }

      setLoading(false);

    };

    loadInformacion();

  }, [token, authFetch]);

  useEffect(() => {
  const modalElement = document.getElementById("detailModal");

  if (!modalElement) return;

  const handleModalHide = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  modalElement.addEventListener("hide.bs.modal", handleModalHide);

  return () => {
    modalElement.removeEventListener("hide.bs.modal", handleModalHide);
  };
}, []);

  // =========================================
  // FILTROS
  // =========================================

  const filteredInformacion = informacion.filter((item) => {

    // =========================
    // CONTRATO
    // =========================
    const matchesContrato =

      contratoFilter === "" ||

      item.contrato_convenio
        ?.toLowerCase()
        .includes(contratoFilter.toLowerCase());

    // =========================
    // CONTRATANTE
    // =========================
    const matchesContratante =

      contratanteFilter === "" ||

      item.contratante
        ?.toLowerCase()
        .includes(contratanteFilter.toLowerCase());

    // =========================
    // PROGRAMA
    // =========================
    const matchesProgram =

      programFilter === "" ||

      String(item.id_programa) === String(programFilter);

    // =========================
    // FECHA MES/AÑO
    // =========================
    const matchesFecha =

      fechaFilter === "" ||

      item.fecha_inicio?.startsWith(fechaFilter);

    return (
      matchesContrato &&
      matchesContratante &&
      matchesProgram &&
      matchesFecha
    );

  });

  // =========================================
  // PAGINACIÓN
  // =========================================

  const totalPages = Math.ceil(
    filteredInformacion.length / recordsPerPage
  );

  const currentInformacion = filteredInformacion.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const goToPage = (page) => {

    if (page >= 1 && page <= totalPages) {

      setCurrentPage(page);

    }

  };

  const openDetailModal = (item) => {
    setSelectedInfo(item);

    const modalElement = document.getElementById("detailModal");

    const modal = bootstrap.Modal.getOrCreateInstance(modalElement);

    modal.show();
  };

  // =========================================
  // LOADING
  // =========================================

  if (loading) {

    return <p>Cargando información general...</p>;

  }

  // =========================================
  // RENDER
  // =========================================

  return (

    <div className="container mt-4 p-4">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-4">

        <h3>Información General de los Contratos</h3>

        <div className="d-flex gap-2">

          <button className="btn btn-outline-purple" onClick={() => navigate("/session/mod_administrativa/informacion_general/modificaciones_contrato")}>
            <i className="bi bi-pencil-square me-1"></i>
            Modificaciones Contractuales
          </button>

          <button className="btn btn-success" onClick={() =>navigate("/session/mod_administrativa/informacion_general/flujo_caja/flujo_general")}>
            <i className="bi bi-cash-stack me-1"></i>
            Flujo de Caja
          </button>

          <button className="btn btn-sm btn-info" onClick={() =>navigate("/session/mod_administrativa/informacion_general/seguimiento_tecnico/seguimiento_general")}>
            <i className="bi bi-clipboard-data me-1"></i>
            Seguimiento Técnico I
          </button>

          <button className="btn btn-sm btn-warning" onClick={() =>navigate("/session/mod_administrativa/informacion_general/seguimiento_tecnico_dos/seguimiento_general_dos")}>
            <i className="bi bi-bar-chart-line me-1"></i>
            Seguimiento Técnico II
          </button>
          
          <button className="btn btn-sm btn-primary" onClick={() => navigate("/session/mod_administrativa/informacion_general/seguimiento_financiero/seguimiento_financiero_general")}>
            <i className="bi bi-currency-dollar me-1"></i>
            Seguimiento Financiero
          </button>

          <button className="btn btn-outline-pink" onClick={() =>navigate("/session/mod_administrativa/informacion_general/create_informacion_general")}>
            <i className="bi bi-plus-circle me-1"></i>
            Crear Información General
          </button>


      </div>

    </div>

      {/* FILTROS */}

      <div className="row mb-3">

        {/* CONTRATO */}

        <div className="col-md-3">

          <label className="m-1">Contrato / Convenio</label>

          <input
            type="text"
            className="form-control"
            value={contratoFilter}
            onChange={(e) => {

              setContratoFilter(e.target.value);
              setCurrentPage(1);

            }}
          />

        </div>

        {/* CONTRATANTE */}

        <div className="col-md-3">

          <label className="m-1">Contratante</label>

          <input
            type="text"
            className="form-control"
            value={contratanteFilter}
            onChange={(e) => {

              setContratanteFilter(e.target.value);
              setCurrentPage(1);

            }}
          />

        </div>

        {/* PROGRAMA */}

        <div className="col-md-3">

          <label className="m-1">Programa</label>

          <SearchSelect
            options={[
              { value: "", label: "Todos" },
              ...programOptions
            ]}
            value={programFilter}
            onChange={(val) => {

              setProgramFilter(val);
              setCurrentPage(1);

            }}
            placeholder="Buscar programa..."
          />

        </div>

        {/* FECHA */}

        <div className="col-md-3">

          <label className="m-1">Mes / Año</label>

          <input
            type="month"
            className="form-control"
            value={fechaFilter}
            onChange={(e) => {

              setFechaFilter(e.target.value);
              setCurrentPage(1);

            }}
          />

        </div>

      </div>

      {/* TABLA */}

      {currentInformacion.length > 0 ? (

        <>

          <div className="table-responsive">

            <table className="table table-hover">
              <thead className="table-secondary">

                <tr>

                  <th>Programa</th>
                  <th>Contrato</th>
                  <th>Contratante</th>
                  <th>Inicio</th>
                  <th>Fin</th>
                  <th>Acciones</th>

                </tr>

              </thead>

              <tbody>

                {currentInformacion.map((item) => (

                  <tr key={item.id}>
                    <td>{item.program_name}</td>
                    <td>{item.contrato_convenio}</td>
                    <td>{item.contratante}</td>
                    <td>{item.fecha_inicio}</td>
                    <td>{item.fecha_fin}</td>
                    <td>

                      <button className="btn btn-sm btn-secondary m-1" onClick={() => openDetailModal(item)}>
                        <i className="bi bi-eye"></i>
                      </button>

                      <button className="btn btn-sm btn-outline-purple me-1" onClick={() =>navigate(`/session/mod_administrativa/informacion_general/modificacion_contrato/${item.id}`)}>
                        <i className="bi bi-pencil-square me-1">
                          {" "}Modificación
                        </i>
                      </button>

                      <button className="btn btn-sm btn-success me-1" onClick={() =>navigate(`/session/mod_administrativa/informacion_general/flujo_caja/flujo/${item.id}`)}>
                        <i className="bi bi-cash-stack me-1"></i>
                        Flujo
                      </button>

                      <button className="btn btn-sm btn-info me-1" onClick={() =>navigate(`/session/mod_administrativa/informacion_general/seguimiento_tecnico/seguimiento/${item.id}`)}>
                        <i className="bi bi-clipboard-data me-1"></i>
                        Seguimiento I
                      </button>

                      <button className="btn btn-sm btn-warning me-1" onClick={() =>navigate(`/session/mod_administrativa/informacion_general/seguimiento_tecnico_dos/seguimiento_dos/${item.id}`)}>
                          <i className="bi bi-bar-chart-line me-1"></i>
                          Seguimiento II
                      </button>

                      <button className="btn btn-sm btn-primary me-1" onClick={() => navigate(`/session/mod_administrativa/informacion_general/seguimiento_financiero/seguimiento_financiero/${item.id}`)}>
                        <i className="bi bi-currency-dollar me-1"></i>
                        Seguimiento Financiero
                      </button>

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

          {/* PAGINACIÓN */}

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />

        </>

      ) : (

        <p>No hay información general registrada.</p>

      )}


      {/* MODAL DETALLE */}

      <div className="modal fade" id="detailModal" tabIndex="-1">

        <div className="modal-dialog modal-lg modal-dialog-scrollable">

          <div className="modal-content">

            {/* HEADER */}

            <div className="modal-header">

              <h5 className="modal-title">Detalle Información General Contratos</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal"> </button>

            </div>

            {/* BODY */}

            <div className="modal-body">

              {selectedInfo && (

                <div className="row">

                  <div className="col-md-6 mb-3">

                    <strong>Nombre del programa:</strong>
                    <div>
                      {selectedInfo.program_name}
                    </div>

                  </div>

                  <div className="col-md-6 mb-3">

                    <strong>Número de Contrato / Convenio:</strong>
                    <div>
                      {selectedInfo.contrato_convenio}
                    </div>

                  </div>

                  <div className="col-md-6 mb-3">

                    <strong>Área PCS:</strong>
                    <div>
                      {selectedInfo.area_name}
                    </div>

                  </div>

                  <div className="col-md-6 mb-3">

                    <strong>Contratante:</strong>
                    <div>
                      {selectedInfo.contratante}
                    </div>

                  </div>


                  <div className="col-md-6 mb-3">

                    <strong>Centro de costos:</strong>
                    <div>
                      {selectedInfo.cost_center}
                    </div>

                  </div>

                  <div className="col-md-6 mb-3">

                    <strong>Lugar de ejecución:</strong>
                    <div>
                      {selectedInfo.lugar_ejecucion}
                    </div>

                  </div>

                  

                  <div className="col-md-6 mb-3">

                    <strong>Cobertura Contratada:</strong>
                    <div>
                      {selectedInfo.cobertura}
                    </div>

                  </div>


                  <div className="col-md-6 mb-3">

                    <strong>Tipo de cobertura:</strong>
                    <div>
                      {selectedInfo.tipo_cobertura}
                    </div>

                  </div>


                  <div className="col-md-6 mb-3">

                    <strong>Fecha de inicio:</strong>
                    <div>
                      {selectedInfo.fecha_inicio}
                    </div>

                  </div>


                  <div className="col-md-6 mb-3">

                    <strong>Fecha de terminación:</strong>
                    <div>
                      {selectedInfo.fecha_fin}
                    </div>

                  </div>


                  <div className="col-md-6 mb-3">

                    <strong>Valor del contrato antes del IVA:</strong>
                    <div>
                      ${Number(selectedInfo.valor_contrato_antes_iva).toLocaleString()}
                    </div>

                  </div>


                  <div className="col-md-6 mb-3">

                    <strong>Plazo de pago:</strong>
                    <div>{selectedInfo.plazo_pago}</div>

                  </div>


                  <div className="col-md-6 mb-3">

                    <strong>Días de duración contrato:</strong>
                    <div>
                      {selectedInfo.dias_duracion_contrato}
                    </div>

                  </div>


                  <div className="col-12 mb-3">

                    <strong>Objeto:</strong>
                    <div className="border rounded p-3 bg-light">
                      {selectedInfo.objeto}
                    </div>

                  </div>

                </div>

              )}

            </div>

            {/* FOOTER */}

            <div className="modal-footer">

              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                Cerrar
              </button>

            </div>

          </div>

        </div>

      </div>

    </div>

  );

};

export default InformacionGeneral;